import { render, staticRenderFns } from "./PlayerMonitorSubscriberRemoveModal.vue?vue&type=template&id=3b79f8c6&scoped=true&"
import script from "./PlayerMonitorSubscriberRemoveModal.vue?vue&type=script&lang=ts&"
export * from "./PlayerMonitorSubscriberRemoveModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b79f8c6",
  null
  
)

export default component.exports